import _products_scanner_index from './src/pages/products/scanner/index.svelte'
import _products_index from './src/pages/products/index.svelte'
import _system_index from './src/pages/system/index.svelte'
import _logs_index from './src/pages/logs/index.svelte'
import _users_new from './src/pages/users/new.svelte'
import _customers_index from './src/pages/customers/index.svelte'
import _users_index from './src/pages/users/index.svelte'
import _orders_index from './src/pages/orders/index.svelte'
import _batch_index from './src/pages/batch/index.svelte'
import _products__id__index from './src/pages/products/[id]/index.svelte'
import _users__userId__index from './src/pages/users/[userId]/index.svelte'
import _logs__collection__index from './src/pages/logs/[collection]/index.svelte'
import _logs__collection___id_ from './src/pages/logs/[collection]/[id].svelte'
import _orders__id_ from './src/pages/orders/[id].svelte'
import _customers__id_ from './src/pages/customers/[id].svelte'
import _index from './src/pages/index.svelte'
import __fallback from './src/pages/_fallback.svelte'
import _customers__layout from './src/pages/customers/_layout.svelte'
import _login from './src/pages/login.svelte'
import _users__layout from './src/pages/users/_layout.svelte'
import _logs__layout from './src/pages/logs/_layout.svelte'
import __layout from './src/pages/_layout.svelte'
import _orders__layout from './src/pages/orders/_layout.svelte'
import _products__layout from './src/pages/products/_layout.svelte'


 export const routes = [
{
  "layouts": [
    __layout,
    _products__layout
  ],
  "isFallback": false,
  "path": "/products/scanner/index",
  "component": _products_scanner_index,
  "regex": "^/products/scanner/index",
  "name": "scanner/index",
  "ranking": "ZZZZ",
  "url": "/products/scanner/index"
},
{
  "layouts": [
    __layout,
    _products__layout
  ],
  "isFallback": false,
  "path": "/products/index",
  "component": _products_index,
  "regex": "^/products/index",
  "name": "products/index",
  "ranking": "ZZZ",
  "url": "/products/index"
},
{
  "layouts": [
    __layout
  ],
  "isFallback": false,
  "path": "/system/index",
  "component": _system_index,
  "regex": "^/system/index",
  "name": "system/index",
  "ranking": "ZZZ",
  "url": "/system/index"
},
{
  "layouts": [
    __layout,
    _logs__layout
  ],
  "isFallback": false,
  "path": "/logs/index",
  "component": _logs_index,
  "regex": "^/logs/index",
  "name": "logs/index",
  "ranking": "ZZZ",
  "url": "/logs/index"
},
{
  "layouts": [
    __layout,
    _users__layout
  ],
  "isFallback": false,
  "path": "/users/new",
  "component": _users_new,
  "regex": "^/users/new",
  "name": "users/new",
  "ranking": "ZZZ",
  "url": "/users/new"
},
{
  "layouts": [
    __layout,
    _customers__layout
  ],
  "isFallback": false,
  "path": "/customers/index",
  "component": _customers_index,
  "regex": "^/customers/index",
  "name": "customers/index",
  "ranking": "ZZZ",
  "url": "/customers/index"
},
{
  "layouts": [
    __layout,
    _users__layout
  ],
  "isFallback": false,
  "path": "/users/index",
  "component": _users_index,
  "regex": "^/users/index",
  "name": "users/index",
  "ranking": "ZZZ",
  "url": "/users/index"
},
{
  "layouts": [
    __layout,
    _orders__layout
  ],
  "isFallback": false,
  "path": "/orders/index",
  "component": _orders_index,
  "regex": "^/orders/index",
  "name": "orders/index",
  "ranking": "ZZZ",
  "url": "/orders/index"
},
{
  "layouts": [
    __layout
  ],
  "isFallback": false,
  "path": "/batch/index",
  "component": _batch_index,
  "regex": "^/batch/index",
  "name": "batch/index",
  "ranking": "ZZZ",
  "url": "/batch/index"
},
{
  "layouts": [
    __layout,
    _products__layout
  ],
  "isFallback": false,
  "path": "/products/[id]/index",
  "component": _products__id__index,
  "paramKeys": [
    "id"
  ],
  "regex": "^/products/([^/]+)/index",
  "name": "id/index",
  "ranking": "ZZAZ",
  "url": "/products/:id/index"
},
{
  "layouts": [
    __layout,
    _users__layout
  ],
  "isFallback": false,
  "path": "/users/[userId]/index",
  "component": _users__userId__index,
  "paramKeys": [
    "userId"
  ],
  "regex": "^/users/([^/]+)/index",
  "name": "userId/index",
  "ranking": "ZZAZ",
  "url": "/users/:userId/index"
},
{
  "layouts": [
    __layout,
    _logs__layout
  ],
  "isFallback": false,
  "path": "/logs/[collection]/index",
  "component": _logs__collection__index,
  "paramKeys": [
    "collection"
  ],
  "regex": "^/logs/([^/]+)/index",
  "name": "collection/index",
  "ranking": "ZZAZ",
  "url": "/logs/:collection/index"
},
{
  "layouts": [
    __layout,
    _logs__layout
  ],
  "isFallback": false,
  "path": "/logs/[collection]/[id]",
  "component": _logs__collection___id_,
  "paramKeys": [
    "collection",
    "id"
  ],
  "regex": "^/logs/([^/]+)/([^/]+)",
  "name": "collection/id",
  "ranking": "ZZAA",
  "url": "/logs/:collection/[id]"
},
{
  "layouts": [
    __layout,
    _orders__layout
  ],
  "isFallback": false,
  "path": "/orders/[id]",
  "component": _orders__id_,
  "paramKeys": [
    "id"
  ],
  "regex": "^/orders/([^/]+)",
  "name": "orders/id",
  "ranking": "ZZA",
  "url": "/orders/:id"
},
{
  "layouts": [
    __layout,
    _customers__layout
  ],
  "isFallback": false,
  "path": "/customers/[id]",
  "component": _customers__id_,
  "paramKeys": [
    "id"
  ],
  "regex": "^/customers/([^/]+)",
  "name": "customers/id",
  "ranking": "ZZA",
  "url": "/customers/:id"
},
{
  "layouts": [
    __layout
  ],
  "isFallback": false,
  "path": "/index",
  "component": _index,
  "regex": "^/index",
  "name": "/index",
  "ranking": "ZZ",
  "url": "/index"
},
{
  "layouts": [
    __layout
  ],
  "isFallback": true,
  "path": "/_fallback",
  "component": __fallback,
  "regex": "^/",
  "name": "/_fallback",
  "ranking": "ZZ",
  "url": "/_fallback"
},
{
  "layouts": [
    __layout
  ],
  "isFallback": false,
  "path": "/login",
  "component": _login,
  "regex": "^/login",
  "name": "/login",
  "ranking": "ZZ",
  "url": "/login"
}
]

 export const options = {"unknownPropWarnings":false}